import { FlashMessages } from "@/components/FlashMessages"
import { Toaster } from "@/components/ui/sonner"
import BlendIcon from "@assets/images/icons/blend.svg"

export function AuthLayout({ children }) {
  return (
    <>
      <Toaster />
      <FlashMessages />
      <main className="flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
        <div className="flex w-full max-w-sm flex-col gap-6">
          {children}
        </div>
      </main>
    </>
  )
}
